
<div class="help-comp" (click)="$event.stopPropagation()">
  <div class="component-wrapper" [class.disabled]="completeSubmission">
    <section>
        <h4 class="help-header">Questions?</h4>
        <i class="material-icons closebutton-pullfloat-right btn-close" (click)="close()"  title="close">close</i>
        <!-- <img src="../images/new_ui/cross-button-gray.png" class="pullfloat-right-help darker" (click)="close()" alt=""> -->
    </section>
    <span class="help-body-text">Ask us anything. Our team is here to help</span>

    <form class="form-horizontal" [formGroup]="helpForm" id="question-form">
        <div class="input-group help-textarea">
            <textarea type="text" class="textarea pop-up-grey-text" style="letter-spacing: 0.02em;" id="helptext" placeholder="Describe your issue or share your ideas" formControlName="helptext" [attr.disabled]="completeSubmission ? '' : null"></textarea>
        </div>
        <div class="error-msg" *ngIf="!hasEmptyQuestions && !helpForm.valid">
            <div class="msg">Please describe your issue or share your ideas</div>
        </div>
        <section>
            <label for="upload">
                <img src="../images/site-icons/attachment-hover.svg" alt="">
                <input type="file" name="image" accept="image/*" id="upload" style="display:none"  (change)="onSelectFile($event)" [attr.disabled]="completeSubmission ? '' : null"> 
                <span class="screenShot">Include screenshot</span>
            </label>
        </section>
        <ng-container *ngIf="fileList">
            <ul *ngFor="let file of fileListArr; let i=index">
                <li>
                    <img src="../images/site-icons/attachment.svg" alt="">
                    <span>{{file.name}}</span>
                </li>
            </ul>
        </ng-container>
        <button class="CapitalizeStyle button button-red" id="send-help-button" title="send" (click)="onSubmit()"  [attr.disabled]="completeSubmission ? '' : null">send</button>
    </form>
  </div>
</div>
 